import { useEffect, useRef, useState } from "react";
import { TextField, List, ListItemButton, Paper, Box } from "@mui/material";
import loader from "../../utils/googleMapsLoader";

const GoogleAddressAutocomplete = ({
  label = "Address",
  onSelect,
  address,
  inputValue,
  setInputValue,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const autocompleteServiceRef = useRef(null);
  const sessionTokenRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    loader.importLibrary("places").then(() => {
      const { AutocompleteService, AutocompleteSessionToken } =
        window.google.maps.places;

      sessionTokenRef.current = new AutocompleteSessionToken();
      autocompleteServiceRef.current = new AutocompleteService();
    });
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (!autocompleteServiceRef.current || !value.trim()) {
      setSuggestions([]);
      return;
    }

    autocompleteServiceRef.current.getPlacePredictions(
      {
        input: value,
        sessionToken: sessionTokenRef.current,
        componentRestrictions: { country: "us" },
      },
      (predictions, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          const floridaOnly = predictions.filter((p) =>
            /,\s*(fl|florida)\b/i.test(p.description)
          );
          setSuggestions(floridaOnly);
        } else {
          setSuggestions([]);
        }
      }
    );
  };

  const handleSelect = (description) => {
    setInputValue(description);
    setSuggestions([]);
    onSelect(description);
  };

  return (
    <Box sx={{ position: "relative" }} ref={containerRef}>
      <TextField
        label={label}
        fullWidth
        variant="filled"
        value={inputValue}
        onChange={handleChange}
        onBlur={() => {
          setInputValue(address);
          setTimeout(() => setSuggestions([]), 200);
        }}
      />
      {suggestions.length > 0 && (
        <Paper
          sx={{
            position: "absolute",
            zIndex: 1000,
            left: 0,
            right: 0,
            maxHeight: 150,
            overflowY: "auto",
          }}
        >
          <List disablePadding>
            {suggestions.map((s) => (
              <ListItemButton
                key={s.place_id}
                onClick={() => handleSelect(s.description)}
              >
                {s.description}
              </ListItemButton>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
};

export default GoogleAddressAutocomplete;
